import { render, staticRenderFns } from "./wsAccordion.vue?vue&type=template&id=bd5dfe34&scoped=true&"
import script from "./wsAccordion.vue?vue&type=script&lang=js&"
export * from "./wsAccordion.vue?vue&type=script&lang=js&"
import style0 from "./wsAccordion.vue?vue&type=style&index=0&id=bd5dfe34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd5dfe34",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VDivider,VExpandTransition,VIcon,VSheet})
